jQuery_T4NT(document).ready(function($) {

    const wiondW = $(document).width()
    const IniFuns = {
        // 适配屏幕方法
        autoReponsive:function () {
            var width = document.body.clientWidth || window.innerWidth;
            if (width < 1279 && width >= 1025) {
                var scale = width / 1280;
                var content = 'width=1280, initial-scale=' + scale + ', minimum-scale=' + scale + ', maximum-scale=' + scale + ', viewport-fit=cover';
                $('meta[name="viewport"]').attr("content", content);
            }
            if (width < 1025 && width >= 750) {
                var scale = width / 1023;
                var content = 'width=1023, initial-scale=' + scale + ', minimum-scale=' + scale + ', maximum-scale=' + scale + ', viewport-fit=cover';
                $('meta[name="viewport"]').attr("content", content);
            }
            if (width < 400) {
                var scale = width / 400;
                var content = 'width=400, initial-scale=' + scale + ', minimum-scale=' + scale + ', maximum-scale=' + scale + ', viewport-fit=cover';
                $('meta[name="viewport"]').attr("content", content);
            }
        },
        // 初始化swiper todo还有2个情况
        iniSwiper:function(){
            if (wiondW > 765) {
                if (!$(".ats-swiper-pc").length) return
                
            }
            if (wiondW <= 765) {
                if (!$(".ats-swiper-mb").length) return
                $(".ats-swiper-mb > div").addClass("swiper-wrapper")
                new Swiper(".ats-swiper-mb", {slidesPerView:1.2,spaceBetween: 10})
            }
            if (!$(".ats-swiper").length) return

        },
        // 初始化锚点方法 暂时只在产品页有锚点
        // iniAnchor:function(){
        //     const navLinks = $('[section-name = "product-anchor"] [tag-name = "tabs-wrapper"] a');
        //     const navWrapper = $('[section-name = "product-anchor"]');
        //     const offsetPar = $('[section-name = "product-anchor"]').attr("offset");
        //     if (!navLinks.length) return
        //     // 产品页的锚点跳转
        //     $('a.ats-anchor').on("click", function(event) {
        //         event.preventDefault();
        //         var target = $(this).attr("href");
        //         var offset = $(target).offset().top - 100;
        //         $("html, body").animate({
        //             scrollTop: offset
        //         }, 1500);
        //     })
        //     // 产品页导航定位
        //     $(window).on("scroll", function() {
        //         $(window).scrollTop()>offsetPar?navWrapper.slideDown():navWrapper.slideUp()

        //         const scrollPosition = $(window).scrollTop();
        //         for (var i = 0; i < navLinks.length; i++) {
        //             const ele = $(navLinks.eq(i).attr('href'));
        //             const nextEle = $(navLinks.eq(i+1).attr('href'));
        //             const eleTop = ele.position().top - 100;
        //             const nextEleTop = nextEle.length?nextEle.position().top:scrollPosition+1;
        //             if ( eleTop <= scrollPosition && nextEleTop > scrollPosition) {
        //             navLinks.removeClass('tw-text-white');
        //             navLinks.eq(i).addClass('tw-text-white');
        //             }
        //         }
        //     });

        //     if(wiondW < 765){
        //         $(".mb-anchor-slide").click(function(){
        //             $('[tag-name="tabs-wrapper"]').slideToggle()
        //         })
        //     }

            
        // },
        // 初始化导航Mega
        iniMega:function() {
            let isMegaRunning = false;
            let timeoutId;
            function iniMega() {
                if (isMegaRunning) {
                clearTimeout(timeoutId);
                return;
                }
                if(!$(".ats-sub-column-item").length) return;
            
                var $pr = $(".ats-mega.t4s-type__mega .type_mn_pr");
                $($pr[0]).removeClass("tw-hidden");
                $('.ats-sub-column li').on('mouseenter', function(event) {
                event.preventDefault();
                $(this).siblings().removeClass('active');
                $(this).addClass('active');
                var collUrl = $(this).find('p').data('collection-url');
                var $atsMega = $(this).closest('.ats-mega');
                $atsMega.find('.ats-sub-column-item').hide();
                $atsMega.find('.ats-sub-column-item[data-collection-url="' + collUrl + '"]').show();
                });
            
                isMegaRunning = true;
            }
            function iniMegaTimer() {
                timeoutId = setTimeout(function() {
                    iniMega();iniMegaTimer();
                }, 1000);
            }
            iniMega();
            iniMegaTimer();
        },
        // 捆绑销售
        iniFbt:function(){

            // 跟新折扣价格
            var totalPriceElement = $('.t4s-fbt__total-price')[0];
            if (totalPriceElement) {
                var observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        updatePrices();
                    });
                });
                observer.observe(totalPriceElement, { childList: true, subtree: false });
            }

            function updatePrices() {
                const ogPrice = parseFloat($('.t4s-fbt__total-price del').text().replace(/[^0-9.-]/g, ''));
                const disPrice = parseFloat($('.t4s-fbt__total-price ins').text().replace(/[^0-9.-]/g, ''));
                const savingNum = (ogPrice - disPrice).toFixed(2);
                const savingsText = $($('.t4s-fbt__text-total-price .t4s-badge-price .money')[0]).text().replace(/\d+(\.\d+)?/, savingNum);
                $('.t4s-fbt__text-total-price .t4s-badge-price .money').text(savingsText);
            }

            // 触摸图片显示名称
            $(document).on('mouseenter mouseleave', '.t4s-fbt__img', function(event) {
                const dataGroupImg = $(this).attr('data-groups-img');
                $(`.t4s-fbt_item-${dataGroupImg} a`).toggleClass('tw-text-vi', event.type === 'mouseenter');
            });


        },
        //手风琴
        iniAccordion:function(){
            if(!$(".accordion-header").length) return
            $(".accordion-header").each(function() {
                if (!$(this).hasClass("active")) $(this).next("div").hide();
            });
            $(".accordion-header").click(function(){
                $(this).next("div").slideToggle("fast", "linear"); // 打开当前折叠内容
                $(this).find("i").toggleClass("tw-rotate-180")
            });
        }
    }

    // 通用初始化
    IniFuns.autoReponsive();
    IniFuns.iniSwiper();
    IniFuns.iniMega();
    IniFuns.iniAccordion();

    // 如果是产品页
    if($("[section-name='product-anchor']")){
        // IniFuns.iniAnchor();
        IniFuns.iniFbt();
    }


    //todo 集合模块view more按钮
    if ($(".t4s-tabs-collection .t4s-tabs-ul li a").length) {
        $(document).on("click", ".t4s-tabs-collection .t4s-tabs-ul li a", function() {
            var url = $(this).parents(".t4s-tabs-ul").next("div").find("t4s-active").find("div[data-collection-url]").attr("data-collection-url");
            $(".view-more-js a").attr("href", url);
        });
    }

    // 切换国家
    $(document).on('click', '.region-popup-wrapper .close-btn-js', function() {
        $(this).closest('.region-popup-wrapper').hide();
    });

    $(document).on('click', '.region-popup-btn-js', function() {
        $(".region-popup-wrapper").show();
    });

    





})
